<template>
    <div class="px-2 pt-2">
        <div v-for="(product, index) in itemsList" :key="`productChart${index}`"
            class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center">
                <div class="mr-1">
                    <div style="width: 50px;height: 50px;">
                        <img v-if="product.imagePath" :src="BASE_URL_File + product.imagePath"
                            class="w-100 h-100 rounded object-fit-cover">
                        <img v-else src="@/assets/images/pages/default.jpg"
                            class="w-100 h-100 rounded object-fit-cover">
                    </div>
                </div>
                <div>
                    <h5 class="font-weight-bolder title-product-chart">
                        {{ product.name }}
                    </h5>
                    <div class="d-flex align-items-center">
                        <h6 class="mb-0 mr-25">{{ product.basePrice.toLocaleString('fa-IR') }}</h6>
                        <h6 class="mb-0">ریال</h6>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center">
                <h4 class="font-weight-bolder mb-0 mr-25">{{ product.totalSold.toLocaleString('fa-IR') }}</h4>
                <h6 class="mb-0">عدد</h6>
            </div>
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BCardBody, BButton, BFormCheckbox } from 'bootstrap-vue';
export default {
    name: 'productChart',
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BCardBody,
        BButton,
        BFormCheckbox
    },
    props: {
        itemsList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
        }
    },
}
</script>

<style lang="scss">
.title-product-chart {
    width: 20vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 1299px) {
        width: 24vw;
    }

    @media (max-width: 767px) {
        width: 44vw;
    }
}
</style>